import React from "react";

import {
  FaTwitterSquare,
  FaFacebookSquare,
  FaLinkedin,
  FaGithubSquare,
  FaInstagramSquare,
} from "react-icons/fa";

const socials = [
  {
    id: 1,
    icon: <FaTwitterSquare />,
    link: "https://twitter.com/IAllekAmazigh",
  },
  {
    id: 2,
    icon: <FaFacebookSquare />,
    link: "https://facebook.com",
  },
  {
    id: 3,
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/in/ilias-allek",
  },
  {
    id: 4,
    icon: <FaGithubSquare />,
    link: "https://github.com/Allek97",
  },
  {
    id: 5,
    icon: <FaInstagramSquare />,
    link: "https://www.instagram.com",
  },
];

export default socials;
